import { render, staticRenderFns } from "./DCConfirmCollectView.vue?vue&type=template&id=5afaa558&"
import script from "./DCConfirmCollectView.vue?vue&type=script&lang=js&"
export * from "./DCConfirmCollectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports